export const getRainSummaryFromHourly = (hourly, now = new Date(), windowMinutes = 60) => {
  const times = hourly?.time || [];
  if (!Array.isArray(times) || times.length === 0) {
    return null;
  }

  const end = new Date(now.getTime() + windowMinutes * 60 * 1000);
  const relevantIndexes = times
    .map((time, idx) => ({ time: new Date(time), idx }))
    .filter(({ time }) => !Number.isNaN(time.getTime()) && time >= now && time < end)
    .map(({ idx }) => idx);

  if (relevantIndexes.length === 0) {
    return null;
  }

  const probabilities = relevantIndexes.map((idx) => hourly?.precipitation_probability?.[idx] || 0);
  const precipitations = relevantIndexes.map((idx) => hourly?.precipitation?.[idx] || 0);
  const snowfallValues = relevantIndexes.map((idx) => hourly?.snowfall?.[idx] || 0);

  const probability = probabilities.reduce((sum, value) => sum + value, 0) / probabilities.length;
  const probabilityMax = Math.max(...probabilities);
  const amount = precipitations.reduce((sum, value) => sum + value, 0) / precipitations.length;
  const amountMax = Math.max(...precipitations);
  const snowfall = snowfallValues.reduce((sum, value) => sum + value, 0);
  const willRain = (
    precipitations.some((value) => value > 0) ||
    probabilities.some((value) => value > 50) ||
    probability > 50 ||
    amount > 0.2
  );
  const isSnow = snowfall > 0 && (snowfall / (amount * relevantIndexes.length || 1)) > 0.5;

  return {
    relevantIndexes,
    probability,
    probabilityMax,
    amount,
    amountMax,
    snowfall,
    willRain,
    isSnow
  };
};
